import { render, staticRenderFns } from "./JourneyConnectionStartDate.vue?vue&type=template&id=2ae06adc&"
import script from "./JourneyConnectionStartDate.vue?vue&type=script&lang=js&"
export * from "./JourneyConnectionStartDate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("n:\\Projects\\Werk\\MarketingDbNEW\\MarketingDb.Web.Zeiss\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ae06adc')) {
      api.createRecord('2ae06adc', component.options)
    } else {
      api.reload('2ae06adc', component.options)
    }
    module.hot.accept("./JourneyConnectionStartDate.vue?vue&type=template&id=2ae06adc&", function () {
      api.rerender('2ae06adc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/JourneyBuilder/Components/Composer/JourneyConnection/GeneralSettings/JourneyConnectionStartDate.vue"
export default component.exports